import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import icon1 from "../../images/icons/icon_wifi.svg";
import icon3 from "../../images/icons/icon_chart.svg";
import icon5 from "../../images/icons/icon_user_2.svg";
import icon7 from "../../images/icons/icon_pen.svg";
import twitterx from "../../images/icons/icon_twitter_x.svg";
import { FaXTwitter } from "react-icons/fa6";
import icon10 from "../../images/avatar/avatar_7.7e7f3c97ebe899f874b1.webp";
import icon11 from "../../images/icons/icon_quote.svg";
import logo from "../../images/site_logo/logo.png";
import logo2 from "../../images/site_logo/logo.png";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header2 = (props) => {
  const [mobailActive, setMobailState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="site_header site_header_2">
      <div
        className={`header_bottom stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-3 col-lg-2 col-5">
              <div className="site_logo">
                <NavLink onClick={ClickHandler} className="site_link" to="/">
                  <img
                    src={logo}
                    alt="Site Logo – Ape It Solutions – Technology, Business Consulting, Software Company Site Template"
                  />
                  <img
                    src={logo2}
                    alt="Site Logo – Ape It Solutions – Technology, Business Consulting, Software Company Site Template"
                  />
                </NavLink>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className="main_menu_inner collapse navbar-collapse justify-content-lg-center"
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list justify-content-center">
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/"
                        id="home_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="dropdown">
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/"
                        id="company_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Company
                      </NavLink>
                      <div
                        className="dropdown-menu mega_menu_wrapper"
                        aria-labelledby="company_submenu"
                      >
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-9">
                              <div className="megamenu_pages_wrapper mb-5">
                                <div className="row">
                                  <div className="col-lg-3 col-md-6">
                                    <NavLink
                                      onClick={ClickHandler}
                                      className="iconbox_block_2"
                                      to="/about"
                                    >
                                      <span className="icon_title_wrap">
                                        <small className="iconbox_icon">
                                          <img
                                            src={icon1}
                                            alt="Wifi SVG Icon"
                                          />
                                        </small>
                                        <small className="iconbox_title">
                                          About Us
                                        </small>
                                      </span>
                                      <span className="description mb-0">
                                        Learn more about Ape It Solutions
                                      </span>
                                    </NavLink>
                                  </div>

                                  <div className="col-lg-3 col-md-6">
                                    <NavLink
                                      onClick={ClickHandler}
                                      className="iconbox_block_2"
                                      to="/portfolio"
                                    >
                                      <span className="icon_title_wrap">
                                        <small className="iconbox_icon">
                                          <img
                                            src={icon3}
                                            alt="Chart SVG Icon"
                                          />
                                        </small>
                                        <small className="iconbox_title">
                                          Portfolio
                                        </small>
                                      </span>
                                      <span className="description mb-0">
                                        Explore our all overview
                                      </span>
                                    </NavLink>
                                  </div>
                                  {/* 
                                  <div className="col-lg-3 col-md-6">
                                    <Link
                                      onClick={ClickHandler}
                                      className="iconbox_block_2"
                                      to="/team"
                                    >
                                      <span className="icon_title_wrap">
                                        <small className="iconbox_icon">
                                          <img
                                            src={icon5}
                                            alt="User Check SVG Icon"
                                          />
                                        </small>
                                        <small className="iconbox_title">
                                          Team
                                        </small>
                                      </span>
                                      <span className="description mb-0">
                                        We are friendly Join our team
                                      </span>
                                    </Link>
                                  </div> */}

                                  <div className="col-lg-3 col-md-6">
                                    <NavLink
                                      onClick={ClickHandler}
                                      className="iconbox_block_2"
                                      to="/services"
                                    >
                                      <span className="icon_title_wrap">
                                        <small className="iconbox_icon">
                                          <img src={icon7} alt="Pen SVG Icon" />
                                        </small>
                                        <small className="iconbox_title">
                                          Services
                                        </small>
                                      </span>
                                      <small className="description mb-0">
                                        Happy to help you!
                                      </small>
                                    </NavLink>
                                  </div>
                                </div>
                              </div>
                              {/* <ul className="btns_group p-0 unordered_list justify-content-start">
                                <li>
                                  <Link
                                    onClick={ClickHandler}
                                    className="btn btn-primary"
                                    to="/contact"
                                  >
                                    <span
                                      className="btn_label"
                                      data-text="Free Consultation"
                                    >
                                      Free Consultation
                                    </span>
                                    <span className="btn_icon">
                                      <i className="fa-solid fa-arrow-up-right"></i>
                                    </span>
                                  </Link>
                                </li>
                              </ul> */}
                            </div>
                            {/* <div className="col-lg-3">
                              <div className="site_author bg-primary">
                                <div className="author_box">
                                  <div className="author_image bg-light">
                                    <img src={icon10} alt="Site Author" />
                                  </div>
                                  <div className="author_box_content">
                                    <h3 className="author_name text-white">
                                      Maverick Phoenix
                                    </h3>
                                    <span className="author_designation text-white">
                                      CEO At Ape It Solutions
                                    </span>
                                  </div>
                                  <div className="quote_icon">
                                    <img src={icon11} alt="Quote Icon" />
                                  </div>
                                </div>
                                <p className="mb-0 text-white">
                                  As a CEO at Ape It Solutions I have been voice
                                  crying in the wilderness, trying to make
                                  requirements clear, use every minute to
                                  deliver the result, and not reinvent the
                                  wheel.
                                </p>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </li>
                    {/* <li className="dropdown">
                      <Link
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/"
                        id="portfolio_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Portfolio
                      </Link>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="portfolio_submenu"
                      >
                        <li>
                          <Link onClick={ClickHandler} to="/portfolio">
                            Portfolio
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/portfolio_details/Explore-Our-IT-Solutions"
                          >
                            Portfolio Details
                          </Link>
                        </li>
                      </ul>
                    </li> */}
                    <li>
                      <NavLink
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/services"
                        id="services_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Services
                      </NavLink>
                    </li>
                    {/* <li className="dropdown">
                      <Link
                        onClick={ClickHandler}
                        className="nav-link"
                        to="/"
                        id="pages_submenu"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Pages
                      </Link>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="pages_submenu"
                      >
                        <li>
                          <Link onClick={ClickHandler} to="/about">
                            About Us
                          </Link>
                        </li>
                        <li className="dropdown">
                          <Link
                            onClick={ClickHandler}
                            className="nav-link"
                            to="/"
                            id="blog_submenu"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Blogs
                          </Link>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="blog_submenu"
                          >
                            <li>
                              <Link onClick={ClickHandler} to="/blog">
                                Our Blogs
                              </Link>
                            </li>
                            <li>
                              <Link
                                onClick={ClickHandler}
                                to="/blog-single/How-Our-Software-Solutions-Drive-Insights."
                              >
                                Blog Details
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li>
                          <Link onClick={ClickHandler} to="/">
                            Careers{" "}
                            <small className="badge bg-danger-subtle text-danger">
                              We’re Hiring
                            </small>
                          </Link>
                        </li>
                      </ul>
                    </li> */}
                    <li>
                      <NavLink onClick={ClickHandler} to="/about">
                        About Us
                      </NavLink>
                    </li>
                    <li>
                      <NavLink onClick={ClickHandler} to="/contact">
                        Contact
                      </NavLink>
                    </li>
                    <li>
                      <NavLink onClick={ClickHandler} to="/career">
                        Career
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="col-xl-3 col-lg-3 col-5">
              <ul className="header_btns_group unordered_list justify-content-end">
                <li>
                  <button
                    className="mobile_menu_btn"
                    onClick={() => setMobailState(!mobailActive)}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_menu_dropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </li>
                <li>
                  {/* <Link
                    onClick={ClickHandler}
                    className="btn btn-primary"
                    to="/contact"
                  >
                    <span className="btn_label" data-text="Get Started">
                      Get Started
                    </span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link> */}
                  <div className=" pe-lg-3">
                    <ul className="social_icons_block unordered_list">
                      <li>
                        <a
                          onClick={ClickHandler}
                          href="https://www.facebook.com/ApeitSolution/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={ClickHandler}
                          href="https://www.instagram.com/apeitsolution/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={ClickHandler}
                          href="https://x.com/ApeitSolution"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {/* <i className="fa-brands fa-twitter"></i> */}
                          <FaXTwitter />
                          {/* <img src={twitterx} alt="" className=" x-logo" style={{color:'blue'}}/> */}
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={ClickHandler}
                          href="https://www.linkedin.com/company/apeitsolutions/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-brands fa-linkedin"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mobail-wrap">
          <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
            <div className="xb-header-menu-scroll">
              <div
                className="xb-menu-close xb-hide-xl xb-close"
                onClick={() => setMobailState(!mobailActive)}
              ></div>
              <nav className="xb-header-nav">
                <MobileMenu />
              </nav>
            </div>
          </div>
          <div
            className="xb-header-menu-backdrop"
            onClick={() => setMobailState(false)}
          ></div>
        </div>
      </div>
    </header>
  );
};

export default Header2;
